module.exports = __webpack_public_path__ + "img/unknow-company.e95ec30.jpg";